var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadPlusLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leadGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1B285E",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2c3d8f",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 116,
    height: 36,
    rx: 18,
    fill: "url(#leadGradient)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 26,
    fontFamily: "Trasandina Web, sans-serif",
    fontSize: 20,
    fontWeight: 600,
    fill: "#FFFFFF",
    letterSpacing: 0.5
  }, "\n            Lead\n        "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75, 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FDBD10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,4 L8,12 M4,8 L12,8",
    stroke: "#1B285E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadPlusLogo);
export default __webpack_public_path__ + "static/media/lead-plus-logo.73c5ae926f5b0ea6a4efebc6f0958f52.svg";
export { ForwardRef as ReactComponent };